// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CodeCountdownTimer_wrapper__gcMJf","icon":"CodeCountdownTimer_icon__3JXZn","rotating":"CodeCountdownTimer_rotating__WCeJk"};